import { ChangeEvent, FC } from 'react'

import styled from 'styled-components'

import InfoIcon from 'src/Assets/Svg/common/info.svg?react'
import { PrimaryInput } from 'src/Components/PrimaryInput'
import { variables } from 'src/Styled/variables'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-basis: 100%;
  padding-left: 44px;
`

const Hint = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`

const IconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  padding-top: 4px;
  color: ${({ theme }) => theme.color.darkGrey};
`

const HintText = styled.p`
  margin: 0;
  font-family: 'Segoe UI', sans-serif;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

type LyricsLinkFieldProps = {
  value?: string
  error?: string
  onChange: (value: string) => void
  onBlur: () => void
}

export const LyricsLinkField: FC<LyricsLinkFieldProps> = ({
  value,
  error,
  onChange,
  onBlur,
}) => (
  <Wrapper>
    <PrimaryInput
      name='lyricsLink'
      placeholder='Add link to lyrics (Optional)'
      value={value ?? ''}
      error={error}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      onBlur={onBlur}
    />
    <Hint>
      <IconWrapper>
        <InfoIcon />
      </IconWrapper>
      <HintText>
        Paste a link from Musixmatch, LyricFind, or Genius. This helps creators
        perform your track accurately.
      </HintText>
    </Hint>
  </Wrapper>
)
